<template>
    <v-alert
        v-if="showAlert"
        :type="alertType"
        class="mx-auto text-center"
        style="position: fixed; top: 20px; left: 0; right: 0; z-index: 9999; max-width: 600px;"
        elevation="2"
        prominent
    >
        {{ alertMessage }}
    </v-alert>
    <v-container fluid>
        <v-card class="pa-4">
            <v-row>
                <v-col class="headline mb-4">
                    <h2>Historial de: {{ providerName }}</h2>
                </v-col>
                <v-col cols="12" sm="2" style="text-align: right">
                    <v-btn style="margin-left: 10px"  @click="$router.back()">Volver</v-btn>
                </v-col>
            </v-row>
            <v-data-table
                :items="history"
                :headers="headers"
                class="elevation-1"
                item-value="id"
                no-data-text="No hi ha registres d’historial"
            >
                <template #item="{ item }">
                    <tr :class="isPastDate(item.delivery_date) ? 'bg-red-lighten-4' : ''">
                        <td>{{ item.description }}</td>
                        <td>{{ item.delivery_date }}</td>
                        <td>{{ item.stock }}</td>
                        <td>{{ item.quantity }}</td>
                        <td>{{ item.status }}</td>
                        <td>
                            <v-btn
                                icon
                                title="Validar"
                                @click="onValidate(item)"
                                :disabled="item.status === 'delivered'"
                            >
                                <v-icon>mdi-check</v-icon>
                            </v-btn>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </v-card>
    </v-container>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import axios from 'axios'

const route = useRoute()

import { useAlert } from '@/composables/useAlert'

const {
    alertMessage,
    alertType,
    showAlert,
    showAlertMessage
} = useAlert()

const isPastDate = (dateStr) => {
    const today = new Date().toISOString().split('T')[0]
    return dateStr < today
}

const providerId = route.params.provider
const history = ref([])
const providerName = ref('')

const headers = [
    { title: 'Descripción', value: 'description' },
    { title: 'Fecha de reparto', value: 'delivery_date' },
    { title: 'Stock', value: 'stock' },
    { title: 'Cantidad', value: 'quantity' },
    { title: 'Estado', value: 'status' },
    { title: 'Acciones', value: 'actions', sortable: false }
]

const onValidate = async (item) => {
    try {
        await axios.post(`/api/admin/departures/${providerId}/validateLine/${item.stock}`, {}, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`
            }
        })

        await fetchDeparturesLines()
    } catch (error) {
        if (error.response?.data?.message) {
            showAlertMessage(error.response.data.message, 'error')
        } else {
            showAlertMessage('Error inesperado al validar la salida', 'error')
        }
    }
}

const fetchDeparturesLines = async () => {
    try {
        const { data } = await axios.get(`/api/admin/departures/history/${providerId}`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`
            }
        })

        history.value = data

        // Carrega nom del proveïdor
        const res = await axios.get(`/api/admin/providers/${providerId}`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`
            }
        })
        providerName.value = res.data.name

    } catch (e) {
        console.error('Error carregant l’historial:', e)
        if (e.response?.data?.message) {
            showAlertMessage(e.response.data.message, 'error')
        } else {
            showAlertMessage('Error carregant l’historial')
        }
    }
}

onMounted(fetchDeparturesLines)
</script>
